export default "__VITE_ASSET__88ef22ca__"